import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import AddIcon from '@mui/icons-material/Add';
import CheckIcon from '@mui/icons-material/Check';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

import Button from '@shared/atoms/Button';
import T from '@shared/atoms/Typography';
import theme from '@shared/themes/default';
import { courseStatus } from '@shared/const';

import { useCourse } from '../../../../contexts/CourseContext';

const SectionWrapper = styled.section`
  background: ${theme.palette.darkWrapper};
  padding: ${theme.spacing.s};
`;

const ContentWrapper = styled.section`
  background: ${theme.palette.darkDistinct};
  padding: ${theme.spacing.s};
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.m2};
`;

const TitleWrapper = styled.div`
  padding: ${theme.spacing.s} 0;
`;

const ButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.s};
  align-items: flex-start;
  max-width: 250px;
`;

const Integrations = () => {
  const { t } = useTranslation();
  const { submitting, course, clearMoodleCourseUrl, syncMoodleCourse } =
    useCourse();
  const [loadingSync, setLoadingSync] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);

  const hasMoodleUrl = !!course?.moodleCourseUrl;
  const isPublished = course?.status === courseStatus.PUBLISHED;

  const handleCreateInGlup = () => {
    setLoadingSync(true);
    syncMoodleCourse();
  };

  const handleDeleteReference = () => {
    setLoadingDelete(true);
    clearMoodleCourseUrl();
  };

  useEffect(() => {
    if (!submitting) {
      if (loadingSync) {
        setLoadingSync(false);
      }
      if (loadingDelete) {
        setLoadingDelete(false);
      }
    }
  }, [submitting, loadingSync, loadingDelete]);

  return (
    <SectionWrapper>
      <ContentWrapper>
        <TitleWrapper>
          <T variant="headingS">
            {t('backoffice.courses.integrationsTab.glup')}
          </T>
        </TitleWrapper>
        <ButtonGroup>
          <Button
            ariaLabel={t('backoffice.courses.integrationsTab.createInGlup')}
            onClick={handleCreateInGlup}
            disabled={!isPublished || hasMoodleUrl || loadingSync}
            fullWidth
            loading={loadingSync}
            iconRight={hasMoodleUrl ? CheckIcon : AddIcon}
            type={hasMoodleUrl ? 'secondaryOutline' : 'primary'}
          >
            {t('backoffice.courses.integrationsTab.createInGlup')}
          </Button>
          <Button
            ariaLabel={t('backoffice.courses.integrationsTab.seeInGlup')}
            disabled={!hasMoodleUrl}
            fullWidth
            href={course?.moodleCourseUrl}
            target="blank"
            type="secondary"
            iconRight={OpenInNewIcon}
          >
            {t('backoffice.courses.integrationsTab.seeInGlup')}
          </Button>
          <Button
            ariaLabel={t('backoffice.courses.integrationsTab.deleteReference')}
            onClick={handleDeleteReference}
            disabled={!hasMoodleUrl || loadingDelete}
            fullWidth
            loading={loadingDelete}
            type="secondaryOutline"
            iconRight={DeleteOutlineIcon}
          >
            {t('backoffice.courses.integrationsTab.deleteReference')}
          </Button>
        </ButtonGroup>
      </ContentWrapper>
    </SectionWrapper>
  );
};

export default Integrations;
